import axios from '@axios';

export default {
  // Get all notifications (Web) - ProfileId is automatically extracted from JWT token
  async fetchNotifications(query?: object) {
    return await axios.get('/notifications', { params: query });
  },

  // Get unread notification count
  async fetchUnreadNotificationCount() {
    return await axios.get('/notifications/count');
  },

  // Get notification details by ID
  async fetchNotificationById(id: string) {
    return await axios.get(`/notifications/${id}`);
  },

  // Delete notification by ID
  async deleteNotification(id: string) {
    return await axios.delete(`/notifications/${id}`);
  },

  // Mark notification as read
  async markNotificationAsRead(id: string) {
    return await axios.put(`/notifications/${id}/read`);
  },

  // Mark all notifications as read
  async markAllNotificationsAsRead() {
    return await axios.put('/notifications/mark-all-read');
  },

  // Delete all notifications
  async clearAllNotifications() {
    return await axios.delete('/notifications/clear-all');
  }
};
